export default "__VITE_ASSET__DbKE4A76__"